import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Пешеходный туризм';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Разновидность туристского путешествия, которое осуществляется пешком.</p>
                    <p>Для пешеходного туризма необходимо специальное снаряжение: рюкзак, палатка, обувь и т.п.</p>
                </div>
            </div>
        </>
    );
}